import {
  IconButton,
  useColorMode,
  Icon,
  Tooltip,
} from '@chakra-ui/react'
import { Sun, Moon } from 'lucide-react'

export function ThemeToggle() {
  const { colorMode, toggleColorMode } = useColorMode()

  const isDark = colorMode === 'dark'
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <Tooltip label={label} openDelay={400}>
      <IconButton
        aria-label={label}
        icon={<Icon as={isDark ? Sun : Moon} boxSize={5} />}
        variant="ghost"
        size="sm"
        onClick={toggleColorMode}
      />
    </Tooltip>
  )
}
